/*
 * Collection facet menus (Sort / Colors / Size / Filter dropdowns).
 * Shared by sections/main-collection.liquid and sections/cp2-collection.liquid.
 *
 * Markup contract:
 *   details[data-facet-menu]                 one dropdown; only one stays open at a time
 *   form[data-facet-form]                    checkbox facet inside a panel
 *     data-facet-url                         collection URL the filters apply to
 *     data-facet-section                     section id used to fetch the live result count
 *     [data-facet-clear]                     button that unchecks every box in the form
 *     [data-facet-results]                   submit button; data-facet-results-label="See [count] results"
 *   [data-facet-results-count="N"]           element carrying the current product count (also in fetched HTML)
 *   [data-drawer-sort]                       sort radio inside the Prestige filter drawer
 */
(function () {
  if (window.collectionFacetMenusBound) return;
  window.collectionFacetMenusBound = true;

  var MENU = 'details[data-facet-menu]';
  var FORM = 'form[data-facet-form]';
  var COUNT = '[data-facet-results-count]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function closeMenus(except) {
    toArray(document.querySelectorAll(MENU + '[open]')).forEach(function (menu) {
      if (menu !== except) menu.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    toArray(document.querySelectorAll(MENU + '[open]')).forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });

  document.addEventListener('toggle', function (event) {
    var menu = event.target;
    if (!menu || !menu.matches || !menu.matches(MENU) || !menu.open) return;
    closeMenus(menu);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenus();
  });

  /* ---------- result count label ---------- */

  function setResultsLabel(button, count) {
    var template = button.getAttribute('data-facet-results-label') || 'See [count] results';
    button.textContent = template.replace('[count]', count);
  }

  function applyCount(root, count) {
    if (count === null || count === undefined || count === '') return;
    toArray(root.querySelectorAll(COUNT)).forEach(function (el) {
      el.setAttribute('data-facet-results-count', count);
    });
    toArray(root.querySelectorAll('[data-facet-results]')).forEach(function (button) {
      setResultsLabel(button, count);
    });
  }

  function readCount(root) {
    var el = root.querySelector(COUNT);
    return el ? el.getAttribute('data-facet-results-count') : null;
  }

  // Prestige's Collection section calls this after every AJAX filter/sort change.
  window.syncCollectionProductCount = function (sectionElement, fetchedElement) {
    var count = readCount(fetchedElement);
    if (count === null) return;
    applyCount(sectionElement, count);

    var legacy = fetchedElement.querySelector('[data-collection-product-count]');
    if (legacy) {
      toArray(sectionElement.querySelectorAll('[data-collection-product-count]')).forEach(function (target) {
        target.setAttribute('data-collection-product-count', legacy.getAttribute('data-collection-product-count'));
        target.textContent = legacy.textContent;
      });
    }
  };

  /* ---------- facet forms ---------- */

  function checkboxes(form) {
    return toArray(form.querySelectorAll('input[type="checkbox"]'));
  }

  function buildUrl(form) {
    var base = form.getAttribute('data-facet-url') || window.location.pathname;
    var url = new URL(base, window.location.origin);
    var params = new URLSearchParams(window.location.search);
    var names = {};

    checkboxes(form).forEach(function (input) {
      names[input.name] = true;
    });
    Object.keys(names).forEach(function (name) {
      params.delete(name);
    });
    params.delete('page');
    params.delete('section_id');

    checkboxes(form).forEach(function (input) {
      if (input.checked) params.append(input.name, input.value);
    });

    url.search = params.toString();
    return url;
  }

  function updateClearState(form) {
    var clear = form.querySelector('[data-facet-clear]');
    if (!clear) return;
    var anyChecked = checkboxes(form).some(function (input) { return input.checked; });
    clear.disabled = !anyChecked;
  }

  function sectionOf(form) {
    return form.closest('.shopify-section') || form.closest('[data-section-id]') || document;
  }

  function refreshCount(form) {
    var button = form.querySelector('[data-facet-results]');
    var sectionId = form.getAttribute('data-facet-section');
    if (!button || !sectionId || typeof window.fetch !== 'function') return;

    window.clearTimeout(form._facetTimer);
    form._facetTimer = window.setTimeout(function () {
      var url = buildUrl(form);
      url.searchParams.set('section_id', sectionId);

      var token = {};
      form._facetToken = token;
      button.setAttribute('aria-busy', 'true');

      window.fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (form._facetToken !== token) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var count = readCount(doc);
          if (count !== null) setResultsLabel(button, count);
        })
        .catch(function () {})
        .then(function () {
          if (form._facetToken === token) button.removeAttribute('aria-busy');
        });
    }, 200);
  }

  function bindForm(form) {
    if (form._facetBound) return;
    form._facetBound = true;

    // Prestige's Collection section listens for `change` on [name^="filter."] and would
    // AJAX-filter immediately; these panels apply on "See results" instead.
    form.addEventListener('change', function (event) {
      event.stopPropagation();
      updateClearState(form);
      refreshCount(form);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      window.location.assign(buildUrl(form).toString());
    });

    var clear = form.querySelector('[data-facet-clear]');
    if (clear) {
      clear.addEventListener('click', function (event) {
        event.preventDefault();
        checkboxes(form).forEach(function (input) { input.checked = false; });
        updateClearState(form);
        refreshCount(form);
      });
    }

    updateClearState(form);
  }

  function bindAll(root) {
    toArray((root || document).querySelectorAll(FORM)).forEach(bindForm);
  }

  /* ---------- sort chips inside the Prestige filter drawer ---------- */

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-drawer-sort]')) return;

    var form = input.closest('form');
    var trigger = form ? form.querySelector('[name^="filter."]') : null;

    if (trigger) {
      // Re-use the theme's own AJAX filter handler; it serialises the whole form, sort_by included.
      trigger.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', input.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    }
  });

  // On phones the Prestige drawer collapses every group; open Colors/Size by default like the design.
  function preopenDrawerGroups(root) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 640px)').matches) return;
    toArray((root || document).querySelectorAll('#collection-filter-drawer [data-facet-preopen]')).forEach(function (group) {
      var button = group.querySelector('.Collapsible__Button');
      var inner = group.querySelector('.Collapsible__Inner');
      if (!button || !inner || button.getAttribute('aria-expanded') === 'true') return;
      button.setAttribute('aria-expanded', 'true');
      inner.style.height = 'auto';
      inner.style.overflow = 'visible';
      group.style.overflow = 'visible';
    });
  }

  function init(root) {
    bindAll(root);
    preopenDrawerGroups(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
